import type { ReactNode } from 'react'
import FlashMessages from '@/components/FlashMessages'

interface AuthLayoutProps {
  children: ReactNode
  title: string
  // Tailwind max-w-* for the content column. Defaults to the narrow auth-form
  // width; wider pages (e.g. pricing) pass a larger value.
  maxWidth?: string
}

export default function AuthLayout({ children, title, maxWidth = 'max-w-md' }: AuthLayoutProps) {
  return (
    <div className="bg-base-200 min-h-screen flex flex-col items-center justify-center p-4">
      <div className={`w-full ${maxWidth} space-y-4`}>
        <div className="text-center mb-2">
          <div className="flex items-center justify-center gap-2">
            <img src="/logo.svg" alt="" className="size-8" />
            <h1 className="text-2xl font-bold">ImpactCheck</h1>
          </div>
          <p className="text-sm text-base-content/60 mt-1">{title}</p>
        </div>

        <FlashMessages />

        {children}

        <div className="mt-8 space-y-2 text-center text-xs text-base-content/40">
          <p>
            Powered by{' '}
            <a
              href="https://www.envisialearning.com"
              target="_blank"
              rel="noopener noreferrer"
              className="link link-hover"
            >
              Envisia Learning
            </a>
          </p>
          <p className="flex items-center justify-center gap-3">
            <a href="/terms" className="link link-hover">Terms</a>
            <a href="/privacy" className="link link-hover">Privacy</a>
            <a href="/cookie-policy" className="link link-hover">Cookie policy</a>
          </p>
        </div>
      </div>
    </div>
  )
}
